<template>
  <div class="drag_group">
    <draggable
        v-model="newAppfiles"
        :group="dragType"
        animation="100"
        filter=".forbid"
        dragClass="dragClass"
        ghostClass="ghostClass"
        chosenClass="chosenClass"
        :move="onMove"
        @end="onEnd"
        @start="onStart"
    >
      <transition-group tag="span" :id="indexSite +'-'+ indexRoom">
        <div class="appfile_info"
             :class="{'greenStyle':appfileItem.applicationanswer === 'B','originStyle':appfileItem.applicationanswer === 'C','noShow':isNoshow(appfileItem)}"
             v-for="(appfileItem,appfileIndex) in newAppfiles"
             :key="dragType + appfileItem.specialAppfile">
          <i class="kdfont kdfont-wode3"></i>
          <span class="ellipsis" style="width: 48px" :title="appfileItem.appfileName">{{
              appfileItem.appfileName
            }}</span>
          <i class="kdfont kdfont-goutong" v-if="appfileItem.hasSendMsg"></i>
          <el-popover
              placement="bottom"
              width="300"
              popper-class="set_pop"
              @after-leave="hideSetPop"
              v-model="setPops[dragType + appfileItem.specialAppfile]">
            <div class="pop_info">
              <img :src="defaultHeadImg" alt="">
              <div class="basedata">
                <span class="name">{{ appfileItem.appfileName }}</span>
                <span class="phone">{{ appfileItem.appfilePhone }}</span>
              </div>
            </div>
            <div class="pop_move">
              <span style="display: flex;align-items: center;flex-wrap: nowrap;">移动至</span>
              <el-select class="select_date" @change="selectSiteIndex = 0" v-model="selectDateIndex" placeholder="请选择" popper-class="pop_select">
                <el-option
                    v-for="(itemDate,indexDate) in cusParam_configData.specialArrTimeDateList"
                    :key="itemDate"
                    :label="dateFormat('MM月dd号', itemDate)"
                    :value="indexDate">
                </el-option>
              </el-select>
              <el-select class="select_site" v-model="selectSiteIndex" placeholder="请选择" popper-class="pop_select">
                <el-option
                    v-for="(itemSite,indexSite) in cusParam_configData.specialArrTimeRangeListEntities[selectDateIndex].specialArrTimeRoomListEntities"
                    :key="itemSite.specialArrTimeRange"
                    :label="itemSite.specialArrTimeRange"
                    :value="indexSite">
                </el-option>
              </el-select>
            </div>
            <div class="pop_divider"></div>
            <div class="pop_join">
              <div class="join_item" @click="joinState = true"><i class="kdfont"
                                                                  :class="[joinState === true ? 'kdfont-liebiaodanxuankuangxuanzhong':'kdfont-danxuankuang-weixuan']"></i>参加
              </div>
              <div class="join_item" @click="joinState = false"><i class="kdfont"
                                                                   :class="[joinState === false ? 'kdfont-liebiaodanxuankuangxuanzhong':'kdfont-danxuankuang-weixuan']"></i>不参加
              </div>
            </div>
            <div class="pop_refuse" v-show="joinState === false">
              <el-select class="select_refuse" :class="{'selectRedTip':verifyStatus && selectRejectIds.length === 0}"
                         multiple
                         v-model="selectRejectIds" placeholder="请选择拒绝原因" popper-class="pop_select"
                         @change="verifyStatus = false">
                <el-option
                    v-for="itemReject in cusParam_rejectRsn"
                    :key="itemReject.key"
                    :label="itemReject.value"
                    :value="itemReject.key">
                  <i class="kdfont" :class="[selectRejectIds.includes(itemReject.key) ? 'kdfont-fuxuankuangxuanzhong_fang':'kdfont-fuxuankuangweixuanzhong_fang']"></i>
                  <span style="margin-left: 3px">{{ itemReject.value }}</span>
                </el-option>
                <el-option key="other" label="其他" value="other">
                  <i class="kdfont" :class="[selectRejectIds.includes('other') ? 'kdfont-fuxuankuangxuanzhong_fang':'kdfont-fuxuankuangweixuanzhong_fang']"></i>
                  <span style="margin-left: 3px">其他</span>
                </el-option>
              </el-select>
              <div class="null_value_tip" v-if="verifyStatus && selectRejectIds.length === 0">值不能为空</div>
              <textarea maxlength="50" :class="{'textAreaRedTip':verifyStatus && selectRejectText === ''}"
                        v-show="selectRejectIds.includes('other')" v-model="selectRejectText"
                        placeholder="请输入原因"></textarea>
              <div class="null_value_tip"
                   v-if="selectRejectIds.includes('other') && verifyStatus && selectRejectText === ''">值不能为空
              </div>
            </div>
            <div class="pop_ops">
              <div class="cancle" @click="setPops[dragType + appfileItem.specialAppfile] = false">取消</div>
              <div class="submit" @click="setAppfile(appfileIndex)">确定</div>
            </div>
            <div class="op_set" slot="reference"><i class="kdfont kdfont-chakanjichuziliao"></i></div>
          </el-popover>
          <el-popover
              placement="bottom"
              width="196"
              popper-class="delete_pop"
              v-model="deletePops[dragType + appfileItem.specialAppfile]">
            <p>移除后将取消候选人的面试，确认移除？</p>
            <div class="pop_ops">
              <div class="cancle" @click="deletePops[dragType + appfileItem.specialAppfile] = false">取消</div>
              <div class="submit" @click="deleteAppfile(appfileIndex)">确定</div>
            </div>
            <div class="op_delete" slot="reference"><span></span></div>
          </el-popover>

        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
//导入draggable组件
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  props: {
    indexSite: Number,
    indexRoom: Number,
    appfiles: Array,
    dragType: String,
    cusParam_configData: Object,
    cusParam_rejectRsn: Array,
    filterAnsState: String,
    filterSeaKey: String,
    curSpecialDayIndex:Number
  },
  computed: {},
  watch: {
    newAppfiles: function (val) {
      this.$emit('update:appfiles', val)
    },
    appfiles: function (val) {
      console.log(val)
      this.newAppfiles = val;
      console.log(this.newAppfiles)
    },
    cusParam_rejectRsn: function (val) {
      console.log(val)
    }
  },
  data() {
    return {
      verifyStatus: false,
      newAppfiles: this.appfiles,
      deletePops: {},
      setPops: {},
      selectDateIndex: 0,
      selectSiteIndex: 0,
      selectRejectIds: [],
      selectRejectText: "",
      joinState: true,
      defaultHeadImg: 'images/pc/emotion/default_person_82_82.png?v=1.0'
    }
  },
  mounted() {
    this.selectDateIndex = this.curSpecialDayIndex;
    this.selectSiteIndex = this.indexSite;
  },
  methods: {
    onMove(e, originalEvent) {
      if (e.from.id === e.to.id) {
        return false;
      }
    },
    onEnd(e, originalEvent) {
      console.log(e)
      console.log(originalEvent)
      if (e.from.id !== e.to.id) {
        this.$emit("siteAppfileOp", {
          "opType": 'move',
          "dragType": this.dragType,
          "appfileObj": null,
          "fromSiteIndex": e.from.id.split("-")[0],
          "fromRoomIndex": e.from.id.split("-")[1],
          "toSiteIndex": e.to.id.split("-")[0],
          "toRoomIndex": e.to.id.split("-")[1],
          "tositeAppfileIndex": e.newIndex
        })
      }
    },
    onStart() {

    },
    deleteAppfile(index) {
      if (this.dragType === 'site') {
        this.$emit("siteAppfileOp", {
          "opType": 'delete',
          "dragType": this.dragType,
          "appfileObj": this.newAppfiles[index],
          "fromSiteIndex": this.indexSite,
          "fromRoomIndex": this.indexRoom,
          "toSiteIndex": null,
          "tositeAppfileIndex": null
        })
      }
      this.newAppfiles.splice(index, 1);
    },
    setAppfile(appfileIndex) {
      this.verifyStatus = true;
      if (!this.joinState && !this.selectRejectIds.length) {
        return
      }
      if (!this.joinState && this.selectRejectIds.includes('other') && this.selectRejectText === '') {
        return
      }
      let appfileObj = this.newAppfiles[appfileIndex];
      appfileObj.applicationanswer = this.joinState ? 'B' : 'C';
      appfileObj.hasSendMsg = false;
      appfileObj.refusalreason = [];
      this.selectRejectIds.forEach((item, index) => {
        if (item !== 'other') {
          appfileObj.refusalreason.push(item);
        }
      })
      if (this.selectRejectIds.includes('other')) {
        appfileObj.refusalcause = this.selectRejectText;
      }
      console.log(appfileObj.refusalreason, appfileObj.refusalcause)
      if(this.curSpecialDayIndex === this.selectDateIndex && this.indexSite === this.selectSiteIndex){
        this.$emit("siteAppfileOp", {
          "opType": 'updateState',
          "dragType": this.dragType,
          "appfileObj": appfileObj,
          "fromSiteIndex": this.indexSite,
          "toSiteIndex": this.selectSiteIndex,
          "toDateIndex": this.selectDateIndex,
          "tositeAppfileIndex": null
        })
      }else {
        this.deleteAppfile(appfileIndex);
        this.$emit("siteAppfileOp", {
          "opType": 'handmove',
          "dragType": this.dragType,
          "appfileObj": appfileObj,
          "fromSiteIndex": this.indexSite,
          "toSiteIndex": this.selectSiteIndex,
          "toDateIndex": this.selectDateIndex,
          "tositeAppfileIndex": null
        })
      }
      this.setPops[this.dragType + appfileObj.specialAppfile] = false;


    },
    changeselect() {
      console.log(this.selectDateIndex)
    },
    hideSetPop() {
      this.selectDateIndex = 0;
      this.selectSiteIndex = 0;
      this.selectRejectIds = [];
      this.selectRejectText = '';
      this.joinState = true;
      this.verifyStatus = false;
    },
    isNoshow(appfileObj) {
      if (this.filterAnsState && appfileObj.applicationanswer !== this.filterAnsState) {
        return true
      }
      if (this.filterSeaKey && !appfileObj.appfileName.includes(this.filterSeaKey)) {
        return true
      }
      return false;
    }
  }

}
</script>
<style lang="less">
.drag_group > div {
  width: 100%;
  height: 100%;
}

.drag_group > div > span {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.drag_group {
  flex-grow: 1;
  flex-shrink: 1;

  .appfile_info {
    width: 90px;
    height: 40px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 1px;
    margin: 0 10px 10px 0;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    cursor: default;

    &:hover {
      .op_set, .op_delete {
        display: flex;
      }
    }

    .kdfont-wode3 {
      margin-right: 6px;
      color: #666;
      font-size: 16px;
    }

    .kdfont-goutong {
      position: absolute;
      top: 0;
      left: 0;
      color: #276ff5;
      font-size: 12px;
    }

    .op_set {
      position: absolute;
      top: -7px;
      right: 15px;
      width: 14px;
      height: 14px;
      padding-bottom: 2px;
      border-radius: 50%;
      background: #276FF5;
      color: #fff;
      display: none;
      align-items: center;
      justify-content: center;

      i {
        font-size: 14px;
        display: block;
        transform: scale(0.733);
      }
    }

    .op_delete {
      position: absolute;
      top: -7px;
      right: -7px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #FB2323;
      color: #fff;
      display: none;
      align-items: center;
      justify-content: center;

      span {
        height: 1px;
        width: 8px;
        background: #fff;
      }
    }
  }

  .greenStyle {
    border-color: #6DD18E;
    background: #F2FFF5;
    color: #6DD18E;

    .kdfont-wode3 {
      color: #6DD18E;
    }
  }

  .originStyle {
    border-color: #fc8555;
    background: #fff8f2;
    color: #fc8555;

    .kdfont-wode3 {
      color: #fc8555;
    }
  }

  .noShow {
    display: none;
  }
}

.delete_pop, .set_pop {
  font-size: 12px;
  color: #212121;
  margin-top: 40px !important;
  margin-left: -43px !important;

  .el-select {
    margin-left: 8px;

    .is-focus > input {
      border-color: var(--theme-color) !important;
    }

    input {
      height: 34px;
      width: 100px;
      padding: 0 8px;
      padding-right: 26px;
      font-size: 14px;
      color: #212121;
      border-color: #d9d9d9;
      border-radius: 2px;

      &:hover {
        border-color: var(--theme-color) !important;
      }

      &:focus {
        border-color: var(--theme-color) !important;
      }
    }

    .el-icon-arrow-up {
      font-family: kdfont !important;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #666;

      &:before {
        content: "\e652";
      }
    }
  }

  .pop_ops {
    display: flex;
    justify-content: flex-end;
    margin-top: 6px;

    .cancle {
      padding: 5px 18px;
      border: 1px solid #d9d9d9;
      color: #212121;
      border-radius: 2px;
      margin-right: 12px;
      cursor: pointer;

      &:hover {
        border-color: var(--theme-color);
      }
    }

    .submit {
      padding: 5px 18px;
      border: 1px solid var(--theme-color);
      color: #fff;
      background: var(--theme-color);
      border-radius: 2px;
      cursor: pointer;

      &:hover {
        background: var(--theme-color-level5);
        border-color: var(--theme-color-level5);
      }
    }
  }

  .pop_info {
    display: flex;
    align-items: center;

    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #EEE;
      margin-right: 11px;
    }

    .basedata {
      display: flex;
      flex-direction: column;

      .name {
        color: #333;
        margin-bottom: 4px;
      }

      .phone {
        color: #666;
      }
    }
  }

  .pop_move {
    display: flex;
    align-items: center;
    margin-top: 12px;

    .select_site {
      input {
        width: 118px;
      }
    }
  }

  .pop_divider {
    height: 1px;
    background: #EEE;
    margin-top: 12px;
  }

  .pop_join {
    display: flex;
    align-items: center;
    margin-top: 12px;

    .join_item {
      display: flex;
      align-items: center;
      margin-right: 23px;
      cursor: pointer;

      i {
        font-size: 14px;
        margin-right: 5px;
      }

      .kdfont-liebiaodanxuankuangxuanzhong {
        color: var(--theme-color);
      }

      .kdfont-danxuankuang-weixuan {
        color: #d9d9d9;
      }
    }
  }

  .pop_refuse {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 12px;

    .el-select__tags{
      .el-tag{
        background: none;
        border: 1px solid #ccc;
        color: #212121;
        margin: 2px 0 2px 8px;
        padding: 0 8px 0 6px;
        border-radius: 1px;
      }
      .el-tag__close{
        font-family: kdfont!important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        background: none;
        color: #212121;
        font-size: 14px;
        &::before{
          content: "\ebb9";
        }
      }
    }

    .null_value_tip {
      color: var(--error-color);
      height: 0;
    }

    .select_refuse {
      margin-left: 0;

      input {
        width: 100%;
      }
    }

    .selectRedTip {
      input {
        border-color: #FB2323 !important;
      }
    }

    textarea {
      resize: none;
      height: 50px;
      margin-top: 8px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      padding: 10px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:hover {
        border-color: var(--theme-color);
      }

      &:focus {
        border-color: var(--theme-color);
      }
    }

    .textAreaRedTip {
      border-color: #FB2323 !important;
    }
  }
}

.pop_select {
  margin-top: 6px !important;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2) !important;
  padding: 0 !important;
  border: 0 !important;
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  opacity: 1;
  visibility: visible;
  z-index: 1050;
  background-color: #fff;
  border-radius: var(--radius-size);
  max-width: 320px;
  min-width: 67px;

  .el-select-dropdown__list {

    .el-select-dropdown__item {
      position: relative;
      padding: 7px 12px;
      color: var(--primary-text-color);
      font-size: 12px;
      line-height: 18px;
      overflow: hidden;
      cursor: pointer;
      transition: background-color .3s;
      display: flex;
      align-items: center;

      &:hover {
        background-color: var(--disabled-contain-bg);
      }
    }

    .selected {
      color: var(--theme-color) !important;
      background-color: var(--theme-color-level1) !important;
      &::after{
        content: none !important;
      }
    }
  }
  .kdfont{
    font-size: 12px;
  }
}
</style>